module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro5.00821c58.mp3";